import { render, staticRenderFns } from "./viewAngle.vue?vue&type=template&id=17046563&scoped=true"
import script from "./viewAngle.vue?vue&type=script&lang=js"
export * from "./viewAngle.vue?vue&type=script&lang=js"
import style0 from "./viewAngle.vue?vue&type=style&index=0&id=17046563&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17046563",
  null
  
)

export default component.exports